import React from 'react';
import { Link } from 'react-router-dom';

export default function AboutSection({ t, language }) {
  return (
    <section className="py-6 md:py-20 bg-[#f7f5f0]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="w-full fade-in group">
          <h2 className="text-2xl md:text-3xl font-playfair mb-8 text-[#181c24] font-semibold leading-tight text-center">
            {language === 'es' ? (
              <>
                ¿Por qué{' '}
                <span className="relative inline-block" style={{ marginBottom: '0.15em' }}>
                  Assemblage
                  <span
                    className="block absolute left-0 right-0 h-0.5 bg-[#bfa76a] rounded-full"
                    style={{ bottom: '-0.22em' }}
                  ></span>
                </span>
                ?
              </>
            ) : (
              <>
                Why{' '}
                <span className="relative inline-block" style={{ marginBottom: '0.15em' }}>
                  Assemblage
                  <span
                    className="block absolute left-0 right-0 h-0.5 bg-[#bfa76a] rounded-full"
                    style={{ bottom: '-0.22em' }}
                  ></span>
                </span>
                ?
              </>
            )}
          </h2>
          <p className="text-[11px] md:text-xs text-[#181c24]/90 font-light mb-12 leading-relaxed max-w-4xl mx-auto text-center">
            {t.about.belief}
          </p>

          <div className="text-center mt-12">
            <Link
              to="/contact"
              className="inline-block border border-[#bfa76a] text-[#bfa76a] bg-transparent py-3 px-10 rounded-full text-lg font-medium transition-all duration-300 hover:bg-[#bfa76a] hover:text-[#181c24]"
            >
              {t.cta.scheduleConsultation}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
} 